'use client';

import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { getProductConstraint } from '../../../../../schema/product/entry.js';
import { getEventNumber } from '../../../../../schema/sport/entry.js';
import { useSearchParameters } from '../../lib/hooks/useSearchParameters.js';
import { useWager } from '../../wager/entry.browser.js';
import { DrawContext } from './DrawsContext.js';
/**
 * Draw provider that provides information about the current draw.
 *
 * @param param Props
 * @param param.children Component Children
 * @param param.wagerId Wager id to load
 * @returns Provider for {@link DrawContext}
 */
export function WagerDrawProvider({
  children,
  wagerId
}) {
  const params = useSearchParameters('draw', 'event', 'product');
  const {
    data: wagerData
  } = useWager(wagerId);
  const {
    drawNumber: wagerDrawNumber,
    product: wagerProduct
  } = wagerData.coupon;
  const productDrawEventNumber = getEventNumber(1);
  const drawInfo = useMemo(() => {
    let drawNumber;
    let eventNumber = getEventNumber(1);
    // 1. User has entered a correct draw in the query string
    // if (params.draw) { // TODO: support multi draws like Stryktipset
    //   drawNumber = params.draw;
    // }
    // 2. Set first opened draw if empty query string
    if (wagerDrawNumber) {
      drawNumber = wagerDrawNumber;
    }
    // 1. User has entered a correct event in the query string
    if (params.event) {
      eventNumber = params.event;
    }
    // 2. Set event number from first opened draw if empty query string
    else if (productDrawEventNumber) {
      eventNumber = productDrawEventNumber;
    }
    return {
      product: getProductConstraint(wagerProduct),
      eventNumber,
      drawNumber
    };
  }, [params.event, productDrawEventNumber, wagerDrawNumber, wagerProduct]);
  return _jsx(DrawContext.Provider, {
    value: drawInfo,
    children: children
  });
}